module.exports = __webpack_public_path__ + "static/media/ff_analytics.018317e3.png";